import { useEffect, useState, RefObject } from "react";

export const useContainerHeight = (ref: RefObject<HTMLDivElement>, triggerRecalc?: number): number => {
	const [height, setHeight] = useState(0);

	useEffect(() => {
		const element = ref.current; // ✅ capture once

		if (!element) {
			setHeight(0);
			return;
		}

		const updateHeight = () => {
			setHeight(element.offsetHeight);
		};

		// Initial measurement
		updateHeight();

		const resizeObserver = new ResizeObserver(updateHeight);
		resizeObserver.observe(element);

		return () => {
			resizeObserver.unobserve(element); // ✅ detach from the SAME element
			resizeObserver.disconnect();
		};
	}, [ref, triggerRecalc]);

	return height;
};
